
import ProgrammingArrow from "../../../assets/filled/ProgrammingArrow.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ProgrammingArrowIcon({ className, dataTestid = "ProgrammingArrowIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <ProgrammingArrow data-testid={dataTestid} className={classes} {...rest} />
  );
}
